const BOM_REMORA_CATEGORY = "\uFEFFremora_category";

export function isCareItem(data) {
  const hasPrice =
    data.price_normal_price !== undefined &&
    data.price_normal_price !== null &&
    data.price_normal_price !== "";
  const isCareCategory =
    data.remora_category === "CARE" ||
    data[BOM_REMORA_CATEGORY] === "CARE";

  return hasPrice && isCareCategory;
}

export function normalizeCareItem(data) {
  return {
    ...data,
    remora_category:
      data.remora_category === "CARE"
        ? data.remora_category
        : data[BOM_REMORA_CATEGORY],
  };
}
